module.exports = __webpack_public_path__ + "static/media/revise.c6887705.svg";